<template>
  <div class="box">
    <div class="firm-msg">
      <!-- 公司logo -->
      <img
        class="logo"
        src="../../../../../assets/imgs/logo.svg"
        alt=""
      />
      <!-- 公司名 -->
      <div class="content">
        <div>
          xxx发展科技有限公司
          <p class="year">七年老店</p>
        </div>
        <div><p class="id">ID:154965261545122</p></div>
        <div>
          <p class="SecurityDeposit">1000</p>
          <p class="trace-p trace">侦迹金</p>
          <p class="trace-p">准</p>
          <p class="trace-p">保</p>
          <p class="trace-p">原</p>
          <p class="trace-p">源</p>
          <p class="trace-p">修</p>
          <p class="trace-p">价</p>
        </div>
      </div>
      <!-- 评分 -->
      <div class="mark">
        <div v-for="(item, index) in markArr" :key="index">
          <p class="tit">{{ item.tit }}</p>
          <div
            class="star"
            v-for="(item1, index1) in item.mark"
            :key="index1 + 1"
          ></div>
          <div
            class="null"
            v-for="(item1, index1) in 5 - item.mark"
            :key="index1 + 10"
          ></div>
          <span>{{ item.mark }} 星</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listArr: {},
  },
  data() {
    return {
      markArr: [
        {
          tit: "总服务评分：",
          mark: 3,
          id: 1,
        },
        {
          tit: "满意度：",
          mark: 3,
          id: 1,
        },
        {
          tit: "服务态度：",
          mark: 3,
          id: 1,
        },
        {
          tit: "响应速度：",
          mark: 3,
          id: 1,
        },
        {
          tit: "综合评分：",
          mark: 3,
          id: 1,
        },
      ], // 评分
    };
  },
  components: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  .firm-msg {
    height: 90px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    padding: 20px;
    display: flex;
    .logo {
      width: 60px;
      height: 60px;
      margin: auto 0;
      margin-right: 30px;
    }
    .content {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      div {
        width: 100%;
        height: 25px;
        line-height: 25px;
        margin: auto;

        display: flex;
        font-size: 20px;
        color: #333333;
        .year {
          width: 70px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: #fe574a;
          border: 1px solid #fe574a;
          border-radius: 5px;
          font-size: 12px;
          color: #ffffff;
          margin: auto 0;
          margin-left: 30px;
        }
        .id {
          font-size: 12px;
        }
        .SecurityDeposit {
          min-width: 70px;
          height: 20px;
          line-height: 20px;
          background: rgba(97, 144, 232, 0.2);
          border: 1px solid #409eff ;
          border-radius: 5px;
          font-size: 12px;
          color: #409eff ;
          text-align: center;
          margin: auto 0;
          margin-right: 30px;
        }
        .trace-p {
          height: 20px;
          line-height: 20px;
          background: #3bb500;
          border-radius: 5px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
          min-width: 20px;
          margin: auto 0;
          margin-right: 5px;
        }
        .trace {
          width: 50px;

          font-weight: 600;
        }
      }
    }
    .mark {
      width: 210px;
      height: 100%;

      display: flex;
      flex-direction: column;
      div {
        width: 100%;
        height: 15px;
        line-height: 15px;
        margin: auto;
        display: flex;
        .tit {
          min-width: 75px;
          text-align: right;
          font-size: 12px;
          color: #333333;
        }
        .star {
          width: 15px;
          height: 14px;
          background-image: url("../../../../../assets/imgs/shoucang@3x.svg");
          background-size: 100% 100%;
          margin: auto 0;
          margin-right: 2px;
        }
        .null {
          width: 15px;
          height: 14px;
          background-image: url("../../../../../assets/imgs/shoucang-null@3x.svg");
          background-size: 100% 100%;
          margin: auto 0;
          margin-right: 2px;
        }
        span {
          font-size: 12px;
          color: #333333;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
